import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_CONFIRM_ACCOUNT').plugin(axiosPlugin);

let confirmAccountAction = redux.fetchActionCreate();

export const fetchConfirmAccount = (data = {}) => confirmAccountAction(`/users/accounts/verify-account`, data);

export const userConfirmAccount = redux.reducer();